module.exports = __webpack_public_path__ + "static/media/hero-video-poster.a8ad932f.webp";